<template>
  <div class="approval-info-actions">
    <b-button
      class="btn-save mr-2"
      variant="primary"
      size="sm"
      @click="onSave"
      v-if="showSaveButton"
      :disabled="loading"
    >
      <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
      Lưu
    </b-button>
    <b-button
      class="btn-cancel"
      variant="secondary"
      size="sm"
      @click="onCancel"
      :disabled="loading"
    >
      Hủy
    </b-button>
  </div>
</template>

<script>
import { APPROVAL_STEP_STATUS } from '@/utils/enum';
import { checkPermission } from '@/utils/saveDataToLocal';

export default {
  name: 'ApprovalInfoActions',
  props: {
    approvalId: {
      type: [String, Number],
      default: null
    },
    approvalStatus: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Determine if the save button should be shown
     * @returns {boolean}
     */
    showSaveButton() {
      // Only show save button for NEW status
      if (this.approvalStatus !== APPROVAL_STEP_STATUS.NEW) {
        return false;
      }
      
      // Check permissions based on whether it's a new or existing approval
      if (this.approvalId) {
        return this.checkPermission('APPROVAL_UPDATE');
      }
      return this.checkPermission('APPROVAL_INSERT');
    }
  },
  methods: {
    /**
     * Check if user has permission
     * @param {string} permission - Permission to check
     * @returns {boolean}
     */
    checkPermission(permission) {
      return checkPermission(permission);
    },
    
    /**
     * Handle save button click
     */
    onSave() {
      this.$emit('save');
    },
    
    /**
     * Handle cancel button click
     */
    onCancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-info-actions {
  display: flex;
  
  .btn-save {
    width: 70px;
    font-weight: 600;
  }
  
  .btn-cancel {
    width: 70px;
    font-weight: 600;
  }
}
</style>
